import { api } from './configs/axiosConfig';

const endPoint = "/stock";

export const stockAPI = {
    getStockDetailsRpt: async function (pCode, locCode, locName, catCode, subCatCode, itemCode, toDate) {
        const reponse = await api.request({
            url: `${endPoint}/details-report`,
            method: 'GET',
            params: { pCode, locCode, locName, catCode, subCatCode, itemCode, toDate }
        });

        return reponse.data;
    },

}